import React from 'react'
import Nav from './new pages/Nav';
import Hero from './new pages/Heronew';
import Plans from './plans';
import Footer from './footer';
import Offer from './offer';
import Section1 from './new pages/Section01';
import Section2 from './new pages/Section02';
import Section3 from './new pages/Section03';
import Section5 from './new pages/Section04';
import Section4 from './section4';
import { Box } from '@mui/material';
import Scrollbtn from './new pages/Scrollbtn';
import FaqSection from './new pages/Faq';
import Button from '../Button/Button';

const all = () => {
  return (
    <>
      <Nav />
      <Hero />
      <Box sx={{ backgroundColor: 'white', minHeight: 'auto' }}>
        <Section1 />
        <Section2 />
        <Section3 />
        <Plans />
        <Offer />
        {/**<Section4 />
        <Section5 />*/}
        <FaqSection />
        <Footer />
      </Box>
      <Button />
    </>
  )
}

export default all
